/*
 * Overview Messages
 *
 * This contains all the text for the HomePage component.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.topbar.usermenu';

export default defineMessages({
  role: {
    id: `${scope}.{role}`,
    defaultMessage: '{role}',
  },
  changePassword: {
    id: `${scope}.changePassword`,
  },
  changeLanguage: {
    id: `${scope}.changeLanguage`,
  },
  logout: {
    id: `${scope}.logout`,
  },
  changeLanguageText: {
    id: `${scope}.changeLanguageText`,
  },
  changePasswordText: {
    id: `${scope}.changePasswordText`,
  },
  soundsOn: {
    id: `${scope}.soundsOn`,
  },
  soundsOff: {
    id: `${scope}.soundsOff`,
  }
});
